"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaBuilder = void 0;
const zod_1 = require("zod");
class SchemaBuilder {
    schema;
    constructor(schema) {
        this.schema = schema;
    }
    replaceDateField(key, replacement) {
        const { [key]: _, ...restShape } = this.schema.shape;
        const newShape = {
            ...restShape,
            [key]: (replacement ?? zod_1.z.string().datetime()),
        };
        const newSchema = zod_1.z.object(newShape);
        return new SchemaBuilder(newSchema);
    }
    omit(...keys) {
        const shape = { ...this.schema.shape };
        keys.forEach((key) => {
            delete shape[key];
        });
        const newSchema = zod_1.z.object(shape);
        return new SchemaBuilder(newSchema);
    }
    extend(newFields) {
        const newSchema = this.schema.extend(newFields);
        return new SchemaBuilder(newSchema);
    }
    pick(...keys) {
        const shape = keys.reduce((acc, key) => {
            acc[key] = this.schema.shape[key];
            return acc;
        }, {});
        const newSchema = zod_1.z.object(shape);
        return new SchemaBuilder(newSchema);
    }
    merge(otherSchema) {
        const newSchema = this.schema.merge(otherSchema);
        return new SchemaBuilder(newSchema);
    }
    build() {
        return this.schema;
    }
}
exports.SchemaBuilder = SchemaBuilder;
